const cubieVertices = new Float32Array( [
  //front
  -1.0,  1.0,  1.0,
  -1.0, -1.0,  1.0,
  1.0,  1.0,  1.0,

  -1.0, -1.0,  1.0,
  1.0, -1.0,  1.0,
  1.0,  1.0,  1.0,
  //back
  -1.0,  1.0,  -1.0,
  -1.0, -1.0,  -1.0,
  1.0, -1.0,  -1.0,

  1.0, -1.0,  -1.0,
  1.0,  1.0,  -1.0,
  -1.0,  1.0,  -1.0,
  //bottom
  -1.0, -1.0,  -1.0,
  1.0, -1.0,  -1.0,
  -1.0, -1.0,   1.0,

  1.0, -1.0,   1.0,
  -1.0, -1.0,   1.0,
  1.0, -1.0,  -1.0,
  //top
  -1.0,  1.0,  -1.0,
  1.0,  1.0,  -1.0,
  1.0,  1.0,   1.0,

  1.0,  1.0,   1.0,
  -1.0,  1.0,   1.0,
  -1.0,  1.0,  -1.0,
  //left
  -1.0,  1.0, -1.0,
  -1.0, -1.0, -1.0,
  -1.0, -1.0,  1.0,

  -1.0, -1.0,  1.0,
  -1.0,  1.0,  1.0,
  -1.0,  1.0, -1.0,
  //right
  1.0,  1.0, -1.0,
  1.0, -1.0, -1.0,
  1.0,  1.0,  1.0,

  1.0, -1.0,  1.0,
  1.0,  1.0,  1.0,
  1.0, -1.0, -1.0,
]);

const STICKERS: number[][] = [
  [7, 4, 1, 6],
  [4, 1, 6, 8],
  [8, 4, 2, 6],
  [4, 2, 6, 7],
  [7, 6, 1, 3],
  [3, 8, 6, 1],
  [8, 6, 2, 3],
  [3, 7, 6, 2],

  [1, 4, 7, 5],
  [5, 1, 4, 8],
  [2, 4, 8, 5],
  [5, 2, 4, 7],
  [1, 5, 7, 3],
  [5, 8, 3, 1],
  [2, 5, 8, 3],
  [5, 7, 3, 2],
]
const stickerTypes = [0, 1, 2, 3, 2, 1, 3, 0, 2, 0, 3, 1]

export {cubieVertices, STICKERS, stickerTypes};